<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { messageStamp } from 'shared/helpers/timeHelper';

import { useI18n } from 'vue-i18n';
defineProps({
  inboxName: {
    type: String,
    default: '',
  },
  inboxIcon: {
    type: String,
    default: '',
  },
  scheduledAt: {
    type: Number,
    default: 0,
  },
  deliveryReport: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();
</script>

<template>
  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.SENT_FROM') }}
  </span>
  <div class="flex items-center gap-1.5 flex-shrink-0">
    <Icon :icon="inboxIcon" class="flex-shrink-0 text-n-slate-12 size-3" />
    <span class="text-sm font-medium text-n-slate-12">
      {{ inboxName }}
    </span>
  </div>

  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.ON') }}
  </span>
  <span class="flex-1 text-sm font-medium truncate text-n-slate-12">
    {{ messageStamp(new Date(scheduledAt), 'LLL d, h:mm a') }}
  </span>
  <template v-if="deliveryReport">
    <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
      {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.DELIVERED') }}
    </span>
    <span class="flex-shrink-0 text-sm font-medium text-n-slate-12">
      {{
        `${deliveryReport.delivered + deliveryReport.read}/${
          deliveryReport.total
        }`
      }}
    </span>
    <span
      v-if="deliveryReport.completed_at"
      class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap"
    >
      {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.FINISHED') }}
    </span>
    <span
      v-if="deliveryReport.completed_at"
      class="flex-shrink-0 text-sm font-medium text-n-slate-12"
    >
      {{ messageStamp(new Date(deliveryReport.completed_at), 'LLL d, h:mm a') }}
    </span>
  </template>
</template>
